import { makeStyles } from '@material-ui/core/styles';
import { deepPurple } from '@mui/material/colors';

const drawerWidth = 240;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '51%'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      // width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  HeadRoot: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  headMenuButton: {
    marginRight: theme.spacing(2),
  },
  footRoot: {
    flexGrow: 1,
    position: "fixed",
    bottom: 0,
    width: "100%",
  },
  footMenuButton: {
    marginRight: theme.spacing(2),
  },
  list: {
    width: 275,
  },
  listItemIcon: {
    paddingLeft: 15,
    color: "inherit"
  },
  listItem: {
    transition: "background-color 0.5s",
    "&:hover": {
      backgroundColor: theme.palette.primary.lightMain,
      cursor: "pointer",
    },
  },
  logo: {
    marginLeft: 8,
    cursor:"pointer"
  },
  fullList: {
    width: 'auto',
  },
  activeLink: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    '& $listItemIcon': {
      color: "white", // Change the color of ListItemIcon on active link
    },
  },
}));